export default {
    "urban_process_search": {
        "titles": "Processos de Obra",
        "label": "Filtros",
        "model": {
            "process": "@:urban_processes.model.process",
            "classification_type": "@:urban_processes.model.classification_type",
            "subject": "@:urban_processes.model.subject",
            "regime_type": "@:urban_processes.model.regime_type",
            "procedure_type": "@:urban_processes.model.procedure_type",
            "use_type": "@:urban_processes.model.use_type",
            "construction_type": "@:urban_processes.model.construction_type",
            "status": "@:urban_processes.model.status",
            "dicofre": "@:urban_processes.model.dicofre",
            "address": "@:urban_processes.model.address.address",
            "entry_at": "@:urban_processes.model.entry_at",
            "owner": "@:urban_processes.model.entities.owner.title",
            "owner_nif": "@:urban_processes.model.entities.owner.nif",
            "architecture_technician": "@:urban_processes.model.entities.architecture_technician.title",
            "responsible_technician": "@:urban_processes.model.entities.responsible_technician.title",

            "finances": {
                "title": "@:urban_processes.model.finances.title",
                "administration_division": "@:urban_processes.model.finances.administration_division",
                "classification": "@:urban_processes.model.finances.classification",
                "article": "@:urban_processes.model.finances.article",
                "section": "@:urban_processes.model.finances.section",
                "fraction": "@:urban_processes.model.finances.fraction",
            },

            "conservatory": {
                "title": "@:urban_processes.model.conservatory.title",
                "number": "@:urban_processes.model.conservatory.number",
                "name": "@:urban_processes.model.conservatory.name",
            },
        },
        "list": {
            "actions": {
                "create": {
                    "title": "Adicionar Processo",
                    "help": null,
                },
                "view-data": {
                    "title": "Consultar Informação",
                    "help": null,
                },
                "view-on-map": {
                    "title": "Visualizar no mapa",
                    "help": null,
                },
                "edit-geometry": {
                    "title": "Editar Áreas",
                    "help": [
                        "Selecione a área.",
                        "Em seguida, arraste os pontos para modificar a área.",
                        "Para terminar, selecione uma das opções disponíveis.",
                        "<u>NOTA</u>: Alt+Click para eliminar vértices."
                    ],
                },
                "associate-geometry": {
                    "title": "Editar Áreas",
                    "help": null,
                },
                "associate-process": {
                    "title": "Associar Processo",
                    "help": null,
                },
                "link-geometry": {
                    "title": "Associar Áreas",
                    "help": null,
                },
                "unlink-geometry": {
                    "title": "Desassociar Áreas",
                    "help": [
                        "Selecione a(s) áreas(s) que pretende desassociar do processo.",
                        "Para terminar, selecione uma das opções disponíveis."
                    ]
                },
                "confrontation": {
                    "title": "Confrontações",
                    "help": null,
                },
            }
        },
        "msg": {
            "confirm-edit-geometry": "Deseja editar as áreas do processo <strong class='font-weight-bold'>{process}</strong>?",
            "confirm-associate-geometry": "@:urban_processes.msg.confirm-geometry-of-process",
            "confirm-link-geometry": "Deseja associar áreas ao processo <strong class='font-weight-bold'>{process}</strong>?",
            "confirm-unlink-geometry": "Deseja desassociar áreas do processo <strong class='font-weight-bold'>{process}</strong>?",
            "confirm-confrontation": "Deseja determinar as classes de espaço intersetadas pelo processo <strong class='font-weight-bold'>{process}</strong>?",
            "export": {
                "confirm": "Pretende {txt}?",
                "data-ine": "Exportar os centróides para o INE",
                "processing": "Exportação de <b>{total} elemento</b> em  execução... | Exportação de <b>{total} elementos</b> em  execução...",
                "finished": "Exportação de <b>{total} elemento</b> concluída | Exportação de <b>{total} elementos</b> concluída",
            },
        }
    },
    "urban_processes": {
        "title": "Processo | Processo: {process}",
        "model": {
            "process": "Processo",
            "sub_process": "Sub-Processo",
            "classification_type": "Classificação",
            "subject": "Assunto",
            "regime_type": "Tipo Regime",
            "procedure_type": "Tipo Procedimento",
            "use_type": "Tipo Utilização",
            "construction_type": "Tipo Construção",
            "order_type": "Tipo Pedido",
            "status": "Situação",
            "state": "Estado",
            "dicofre": "Freguesia",
            "entry_at": "Data Entrada",
            "obs": "Observações",
            "owner": "Titular",
            "owner_nif": "NIF Titular",
            "architecture_technician": "Téc. Arquitetura",
            "responsible_technician": "Téc. Responsável",

            "use_license": "Licença Utilização",
            "use_license_at": "Data Licença Utilização",
            "construction_license": "Licença Construção",
            "construction_license_at": "Data Licença Construção",

            "address": {
                "title": "Endereço",
                "address": "Morada",
                "dicofre": "Freguesia",
                "postal_code": "Código Postal",
            },

            "finances": {
                "title": "Artigo Matricial",
                "administration_division": "Serviço Finanças",
                "classification": "Classificação",
                "article": "Nº Artigo",
                "section": "Secção",
                "fraction": "Fração",
                "n_associated_records": "Nº Registos Associados",
            },

            "conservatory": {
                "title": "Registo Predial",
                "number": "Nº Registo Predial",
                "name": "Conservatória",
                "date": "Data Registo",
                "n_associated_records": "Nº Registos Associados",
                "areas": {
                    "title": "Áreas (em m²)",
                    "implantation": "Área Implantação Edifício",
                    "dependent": "Área Bruta Dependente",
                    "construction": "Área Bruta Construção",
                    "private": "Área Bruta Privativa",
                    "total": "Área Total Terreno",
                },
                "confrontations": {
                    "title": "Confrontações",
                    "confrontations": "Confrontações",
                    "north": "Norte",
                    "south": "Sul",
                    "east": "Nascente",
                    "west": "Poente",
                }
            },

            "entities": {
                "owner": {
                    "id": "Código",
                    "title": "Titular",
                    "name": "Nome",
                    "email": "E-mail",
                    "phone": "Contato",
                    "nif": "NIF",
                    "address": "Morada",
                    "dicofre": "Freguesia",
                    "postal_code": "Código Postal",
                    "category": "Categoria",
                },
                "architecture_technician": {
                    "id": "Código",
                    "title": "Técnico Arquitetura",
                    "name": "Nome",
                    "email": "E-mail",
                    "phone": "Contato",
                    "nif": "NIF",
                },
                "responsible_technician": {
                    "id": "Código",
                    "title": "Técnico Responsável",
                    "name": "Nome",
                    "email": "E-mail",
                    "phone": "Contato",
                    "nif": "NIF",
                },
                "procedure_manager": {
                    "id": "Código",
                    "title": "Gestor Procedimento",
                    "name": "Nome",
                    "email": "E-mail",
                    "phone": "Contato",
                    "nif": "NIF",
                }
            },

            "requirements": {
                "title": "Requerimentos",
            },

            "inspections": {
                "title": "Fiscalizações",
                "obs": "Observações",
                "date": "Data",
                "files": "Ficheiros",
            },

            "documents": {
                "title": "Documentos",
                "type": "Tipo",
                "filename": "Ficheiro",
                "date": "Data",
                "description": "Observações",
            },

            "areas": {
                "title": "Áreas",
                "total_area": "Área Total",
                "land_area": "Área Terreno",
                "deployment_area": "Área Implantação",
                "construction_area": "Área Construção",
                "dependent_area": "Área Dependente",
                "useful_area": "Área Útil",
                "waterproofing_area": "Área Impermeabilização",
                "easement_area": "Área Cedência",
                "liveable_area": "Área Habitável",
                "covered_area": "Área Coberta",
                "uncovered_area": "Área Descoberta",
                "gross_area": "Área Bruta",
                "gross_construction_area": "Área Bruta de Construção",
                "gross_private_area": "Área Bruta Privativa",
                "gross_dependent_area": "Área Bruta Dependente",
                "total_volume": "Volume Total",
                "building_volume": "Volume Edifício",
                "volumetrics": "Volumetria",
                "sill_quota": "Cota de Soleira",
                "building_height": "Cércea",
                "n_floors_above_sill_quota": "Pisos Acima Cota Soleira",
                "n_floors_below_sill_quota": "Pisos Abaixo Cota Soleira",
                "n_public_parking": "Lug. Estacionamento Públicos",
                "n_private_parking": "Lug. Estacionamento Privados",
                "help": {
                    "total_area": "A área total de um edifício, corresponde à área privativa somada a fração da área comum que é dividida entre todas as unidades.",
                    "land_area": "Área de um prédio ou prédios, qualquer que seja o uso do solo preconizado, sobre o qual incide a operação urbanística.",
                    "deployment_area": "A área de implantação de um edifício é a área de solo ocupada pelo edifício. Corresponde à área do solo contido no interior de um polígono fechado.",
                    "construction_area": "A área de construção do edifício é o somatório das áreas de todos os pisos, acima e abaixo da cota de soleira, com exclusão das áreas em sótão e em cave sem pé-direito regulamentar.",
                    "dependent_area": "A área dependente corresponde às áreas revestidas e fechadas para uso particular, mesmo que consistam divisões comuns, localizadas na parte exterior do imóvel. Compreende então garagens, arrecadações, arrumos, acomodamentos para animais, sótãos ou caves e varandas. Sendo assim será tudo o que não está incluído na área bruta privativa.",
                    "useful_area": "A área útil é a soma das áreas de todos os compartimentos da habitação, incluindo vestíbulos, circulações interiores, instalações sanitárias, arrumos, outros compartimentos de função similar e armários nas paredes, e mede-se pelo perímetro interior das paredes que limitam o fogo, descontando encalços até 30cm, paredes interiores, divisórias e condutas.",
                    "waterproofing_area": "A área de impermeabilização, é o valor expresso em m2 resultante do somatório da área de implantação das construções de qualquer tipo e das áreas de solos pavimentados com materiais impermeáveis ou que proporcionem o mesmo efeito, designadamente em arruamentos, estacionamentos, equipamentos desportivos e logradouros.",
                    "easement_area": "A área de cedência, é a área que deve ser cedida ao Domínio Público, destinada à circulação pedonal e de veículos, à instalação de infraestruturas, a espaços verdes e de lazer, a equipamentos de utilização coletiva, e a estacionamento.",
                    "liveable_area": "A área habitável, é a soma das áreas dos compartimentos da habitação, com excepção de vestíbulos, circulações interiores, instalações sanitárias, arrumos e outros compartimentos de função similar, e mede-se pelo perímetro interior das paredes que limitam o fogo, descontando encalços até 30 cm, paredes interiores, divisórias e condutas.",
                    "covered_area": "A área coberta, é área de uma habitação que, dependendo da sua tipologia, corresponde à superfície delimitada pelo perímetro do extradorso das paredes exteriores ou pela linha média das paredes divisórias.",
                    "uncovered_area": "A área descoberta diz respeito à área do terreno livre. É a área resultante da diferença entra a área do prédio e a área coberta, em projeção horizontal.",
                    "gross_area": "A área bruta, é a superfície total do fogo, medida pelo perímetro exterior das paredes exteriores e eixos das paredes separadoras dos fogos, e inclui varandas privativas, locais acessórios e a quota-parte que lhe corresponda nas circulações comuns do edifício.",
                    "gross_construction_area": "A área bruta de construção corresponde ao somatório das áreas brutas de pavimento edificadas ou susceptíveis de edificação, acima e abaixo da cota de soleira, incluindo escadas e caixas de elevadores. Se a área a construir abaixo da cota de soleira se destinar exclusivamente a estacionamento, o seu valor não será considerado para efeito do cálculo da área bruta de construção.",
                    "gross_private_area": "A área bruta privativa corresponde à superfície total da fração medida pelo perímetro exterior e eixos das paredes que limitam o edifício ou fração.",
                    "gross_dependent_area": "A área bruta dependente de um imóvel é constituída por todas as zonas de utilização exclusiva pelo proprietário da casa, embora estas, se encontrem no exterior da habitação.",
                    "total_volume": "O volume total é o somatório dos volumes de todos os edifícios existentes ou previstos numa porção delimitada de território.",
                    "building_volume": "O volume do edifício é a medida, em unidades de volume, do espaço edificado acima do nível do solo, definido pelas superfícies que contêm as fachadas, a cobertura e o pavimento a que está referida a cota de soleira. Nos casos de elevação da soleira positiva, este pavimento é substituído pelo plano horizontal cujo nível corresponde à cota de soleira deduzida da elevação.",
                    "volumetrics": "A volumetria é o espaço contido pelas superfícies que delimitam a edificação e que, não sendo por ela intersetadas, definem a sua configuração.",
                    "sill_quota": "A cota de soleira é a cota altimétrica da soleira da entrada principal do edifício.",
                    "building_height": "A altura da edificação é a dimensão vertical medida desde a cota de soleira até ao ponto mais alto do edifício, incluindo a cobertura e demais volumes edificados nela existentes, mas excluindo chaminés e elementos acessórios e decorativos, acrescida da elevação da soleira, quando aplicável.",
                    "n_floors_above_sill_quota": "Número de pisos acima da cota de soleira.",
                    "n_floors_below_sill_quota": "Número de pisos abaixo da cota de soleira.",
                    "n_public_parking": "Número de lugares de estacionamento públicos.",
                    "n_private_parking": "Número de lugares de estacionamento privados.",
                }
            },

            "surrounding_space_analysis": {
                "title": "Análise Envolvente",
                "process": "@:urban_processes.model.process",
                "classification_type": "@:urban_processes.model.classification_type",
                "status": "@:urban_processes.model.status",
                "address": "@:urban_processes.model.address.title",
                "owner": "@:urban_processes.model.entities.owner.title",
            }
        },
        "tabs": {
            "general": "Processo",
            "technical_informations": "Informação Técnica",
            "entities": "Entidades",
            "conservatory": "@:urban_processes.model.conservatory.title",
            "finances": "@:urban_processes.model.finances.title",
            "documents": "@:urban_processes.model.documents.title",
            "requirements": "@:urban_processes.model.requirements.title",
            "inspections": "@:urban_processes.model.inspections.title",
            "surrounding_space_analysis": "@:urban_processes.model.surrounding_space_analysis.title",
        },
        "buttons": {
            "save": "@:global.save",
            "delete": "@:global.remove",
            "clear": "@:global.clear",
            "export": "@:global.export",
            "print": "@:global.print",
        },
        "actions": {
            "confrontation": {
                "title": "@:urban_process_search.list.actions.confrontation.title"
            },
            "associate-urbanprocess": {
                "title": "Associar Processo"
            },
            "export": {
                "title": "Exportar Processo"
            },
        },
        "export": {
            "data": {
                "csv": {
                    "name": "CSV",
                    "title": "Exportar para @:urban_processes.export.data.csv.name",
                },
                "xls": {
                    "name": "Excel",
                    "title": "Exportar para @:urban_processes.export.data.xls.name",
                },
                "kml": {
                    "name": "KML",
                    "title": "Exportar para @:urban_processes.export.data.kml.name",
                },
                "gml": {
                    "name": "GML",
                    "title": "Exportar para @:urban_processes.export.data.gml.name",
                },
                "geojson": {
                    "name": "Geojson",
                    "title": "Exportar para @:urban_processes.export.data.geojson.name",
                },
                "shp": {
                    "name": "Shapefile",
                    "title": "Exportar para @:urban_processes.export.data.shp.name",
                },
                "gpkg": {
                    "name": "GeoPackage",
                    "title": "Exportar para @:urban_processes.export.data.gpkg.name",
                },
                "pdf": {
                    "name": "PDF",
                    "title": "Exportar para @:urban_processes.export.data.pdf.name",
                },
                "ine": {
                    "name": "INE - Centróides",
                    "title": "Exportar os centróides para o INE",
                },
            }
        },
        "msg": {
            "confirm-geometry-of-process": "Deseja atualizar as áreas do processo <strong class='font-weight-bold'>{process}</strong>?",
            "confirm-delete": "Deseja eliminar o processo <strong class='font-weight-bold'>{process}</strong>?",
            "confirm-confrontation": "@:urban_process_search.msg.confirm-confrontation",
            "surrounding_space_analysis": {
                "general": "Lista de processos resultante da análise espacial de uma área envolvente com base num raio de ação de {meters}m.",
                "no-result": "A análise espacial não devolveu nenhum processo no raio de ação de {meters}m."
            },
            "export": {
                "confirm": "Deseja exportar o processo <strong class='font-weight-bold'>{process}</strong> para <strong class='font-weight-bold'>{format}</strong>?",
                "processing": "A exportar o processo...",
                "processed": "Exportação concluída"
            }
        }
    },
    "urban_process_confrontations": {
        "title": "Processo | Processo: {process}",
        "title_area": "{area_type}: {area} | Processo: {process} ({area_type}: {area})",
        "form": {
            "workflow": {
                "description": "Foram determinadas as classes de espaço e calculadas as respetivas áreas intersetadas pelo processo.",
                // "description": "Classes de espaço intersetadas pelo processo.",
                "title-result": "Resultado da confrontação:",
                "empty-result": "Não existe nenhuma classe de espaço intersetada pelo processo.",
                "title-error-result": "Ocorreram os seguintes erros a gerar a confrontação:",
                "error-result": "Ocorreu um erro a gerar a confrontação.",
            },
            "columns": {
                "title": "{name}",
                "title_with_total": "{name} (Total: {total})",
                "name": "Classes de Espaço",
                "area": "Área",
                "percentage": "Percentagem",
            }
        },
        "buttons": {
            "close": "@:global.close",
            "export": "@:global.export",
        },
        "msg": {
            "export": {
                "confirm": "Pretende exportar o resultado da confrontação?",
                "processing": "A exportar o resultado...",
                "finished": "Exportação finalizada"
            },
            "error": {
                "form": "@:global.msg.error.form"
            }
        }
    },
    "urban_process_associate_areas": {
        "titles": "Associar Áreas ao Processo | Associar Áreas ao Processo: {process}",
        "title": "Processo | Processo: {process}",
        "label": "Associar Áreas",

        "form": {
            "help": {
                "define_area": "Definir as áreas relativas ao processo",
                "draw_on_map": "Efectue o desenho da área sobre o mapa, utilizando as seguintes ferramentas disponibilizadas para o efeito:",
                "limit_types": "Tipo de Limite:",
                "notes": {
                    "title": "Notas:",
                    "note1": "É possível associar mais do que uma área ao processo.",
                },
                "no_draw_actions": "Não está configurada nenhuma ferramenta para efetuar a associação das áreas.",
            }
        },
        "actions": {
            "draw": "Desenhar",
            "select": "Selecionar",
            "import": "Importar",
        },
        "upload": {
            "help": {
                "propertyFilterTitle": "Áreas relativas ao processo"
            },
            "msg": {
                "no_features": "Não existem áreas para importar.",
                "no_property": "Existem {num} áreas, no entanto, nenhuma está configurada com um dos limites permitidos.",
                "total_status": "Total de elementos",
                "geometry_status": "Elementos com geometrias válidos",
                "property_status": "Elementos com propriedades válidos",
                "import_status": "Elementos importados",
            }
        },


        "buttons": {
            "save": "Gravar",
            "cancel": "Cancelar",
            "close": "Fechar",
        },
    },
    "urban_areas": {
        "titles": "Limites Geográficos",
        "title": "Limite Geográfico",
        "model": {
            "limit_type": "Tipo de Limite",
            "source_type": "Tipo de Fonte",
            "state": "Estado",
            "obs": "Observações"
        },
        "buttons": {
            "save": "@:global.save",
            "delete": "@:global.remove",
        },
        "msg": {
            // "confirm-associate-process": "Deseja atualizar os processos da área selecionada?",
            "confirm-associate-process": "Deseja associar o processo <strong class='font-weight-bold'>{process}</strong> com a área selecionada?",
            "confirm-disassociate-process": "Deseja desassociar o processo <strong class='font-weight-bold'>{process}</strong> da área selecionada?",
            "confirm-delete": "Deseja eliminar a área selecionada?",
        }
    },
    "dashboard": {
        "titles": "Dashboard",
        "label": "Dashboard"
    }
}
